/**
 * Created by eddy on 2017/7/22.
 */
var nb = require('../../nb');
module.exports = nb.define({
        view:{
            $html:[{
                'class':'header-mask'
            },{
                id:'header-dialog',
                'class':['dialog-header collapse',nb.bind('isLogin')],
                $html: [{
                //     tag:'i',
                //     'class':'dialog-back iconfont icon-close'
                // },{
                    $name:'dialogWrapper',
                    'class':'dialog-wrapper',
                    $html:[{
                        'class':'top',
                        tag: 'ul',
                        $html: [{
                            tag: 'li',
                            $html:{
                                tag:'a',
                                $text: '首页',
                                href:'index.html'
                            }
                        },{
                            tag: 'li',
                            $html:{
                                tag:'a',
                                $text: '西区故事',
                                href:'storyList.html'
                            }
                        }, {
                            tag: 'li',
                            $html:[{
                                $name:'seriesList-label',
                                $text: '生活方式'
                            },{
                                $name:'seriesList',
                                'class': 'mobile-series-list',
                                $html:[{
                                    tag:'a',
                                    'class':'series-item',
                                    href:'seriesList.html',
                                    $text:'查看全部'
                                },{
                                    $type: nb.view.List,
                                    $model: 'seriesList'
                                }]
                            }]
                        }, {
                            tag: 'li',
                            $html:{
                                tag:'a',
                                $text: '在线挑选',
                                href:'products.html'
                            }
                        }, {
                            tag: 'li',
                            $html:[{
                                $name:"businessLabel",
                                $text: '加盟合作'
                            // },{
                            //     $name:'businessList',
                            //     'class': 'mobile-business-list',
                            //     $html:{
                            //         $type: nb.view.List,
                            //         $model: 'businessList'
                            //     }
                            }]
                        }]
                    },{
                        'class':'bottom',
                        tag: 'ul',
                        $html: [{
                            'class':'login',
                            tag: 'li',
                            $html:{
                                tag:'a',
                                href:'login.html',
                                $text: '用户登录'
                            }
                        },{
                            'class':'user-account',
                            tag: 'li',
                            $html:{
                                tag:'a',
                                href:'home.html',
                                $text: nb.bind('accountName')
                            }
                        },{
                            tag: 'li',
                            'class':'wish',
                            $html:{
                                tag:'a',
                                href:'wish.html',
                                $text:"心愿清单"
                            }
                        },{
                            $name:"shopCart",
                            tag: 'li',
                            'class':'shopCart',
                            $html:{
                                tag:'a',
                                href:'shopCart.html',
                                $text:"购物车"
                            }
                        },{
                            $name:"exit",
                            tag: 'li',
                            'class':'exit',
                            $html:{
                                tag:'a',
                                $text:"退出登录"
                            }
                        }]
                    }]
                }]
            }]
        },
        method: {
            init: function () {
                var self = this;
                this.$('dialogWrapper').on('click',function (inEvent) {
                        inEvent.stopImmediatePropagation();
                });
                this.$().on('click',function () {
                        self.$().removeClass('active').children('.dialog-header').collapse('toggle');
                });
                this.$('exit').on('click',function () {
                   var model = self.getModel();
                   model.set('exit',new Date());
                   self.$().click();
                });
                this.$('seriesList-label').on('click',function () {
                  self.$('seriesList').slideToggle(300)
                });
                this.$('businessLabel').on('click',function () {
                    self.$('businessList').slideToggle(300)
                });
                // this.$('btn').on('click', function () {
                //     // var model = self.getModel();
                //     // model.set('requireSubmit', new Date());
                //     self.$().removeClass('active');
                // });
                // this.$('exit').on('click',function (inEvent) {
                //     // $.cookie('ARTW_token','');
                //     window.location.href='index.html';
                //     inEvent.stopImmediatePropagation();
                // });
            }
        }
    });



//////////////////
// WEBPACK FOOTER
// ../src/js/view/header/Dialog.js
// module id = 25
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32